jQuery(document).ready(($) => {
  async function injectSvg(imgOrSelector) {
    const el = typeof imgOrSelector === "string"
      ? document.querySelector(imgOrSelector)
      : imgOrSelector;

    if(!el) return null;

    const url = el.getAttribute("src") || el.getAttribute("data-src");
    if (!url) throw new Error("No src/data-src found");
    if (!url.toLowerCase().endsWith(".svg")) {
      throw new Error("URL is not an .svg (you can’t turn PNG/JPG into real SVG without tracing)");
    }

    const res = await fetch(url, { cache: "no-store" });
    if (!res.ok) throw new Error(`Failed to fetch SVG: ${res.status}`);
    const svgText = await res.text();

    const doc = new DOMParser().parseFromString(svgText, "image/svg+xml");
    const svg = doc.querySelector("svg");
    if (!svg) throw new Error("No <svg> tag in fetched file");

    // Optional: preserve classes/id from <img>
    if (el.id) svg.id = el.id;
    svg.classList.add(...el.classList);

    el.replaceWith(svg);
  }

  $(".icon").each((_, img) => {
    injectSvg(img).catch(console.error);
  });

  // Accordion
  $('.or-trust-accordion').each(function () {
    const $accordion = $(this);
    const $items = $accordion.find('.onereach-trust-accordion-item');

    $items.each(function (index) {
      const $header = $(this).find('.onereach-trust-accordion-trigger').first();
      const $panel  = $(this).find('.onereach-trust-accordion-panel').first();
      $header.attr('aria-expanded', 'false');
      $panel.hide().prop('hidden', true);
    });
  });

  $('.onereach-trust-accordion-trigger').on('click', function (e) {
    e.preventDefault();

    const $header = $(this);
    const $item   = $header.closest('.onereach-trust-accordion-item');
    const $panel  = $item.find('.onereach-trust-accordion-panel').first();

    const isOpen = $header.attr('aria-expanded') === 'true';

    if (isOpen) {
      $header.attr('aria-expanded', 'false');
      $panel.stop(true, true).slideUp(200, function () {
        $panel.prop('hidden', true);
      });
    } else {
      $header.attr('aria-expanded', 'true');
      $panel.prop('hidden', false).stop(true, true).slideDown(200);
    }
  });
});

/* ============================================================
   Popup system — works for any .onereach-trust-popup
   Trigger: <button data-popup-trigger="popup-id"> or .onereach-trust-btn-notify (legacy, targets #notifyPopup)
   ============================================================ */
document.querySelectorAll('.onereach-trust-popup').forEach(popup => {
  const popupId  = popup.id;
  const closeBtn = popup.querySelector('.onereach-trust-popup-close');
  const backdrop = popup.querySelector('.onereach-trust-popup-backdrop');

  function openPopup() {
    popup.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    popup.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (closeBtn) closeBtn.addEventListener('click', closePopup);
  if (backdrop)  backdrop.addEventListener('click', closePopup);

  document.querySelectorAll(`a[href="#${popupId}"], [data-popup-trigger="${popupId}"]`).forEach(trigger => {
    trigger.addEventListener('click', (e) => { e.preventDefault(); openPopup(); });
  });

  // Legacy: .onereach-trust-btn-notify opens #notifyPopup
  if (popupId === 'notifyPopup') {
    document.querySelectorAll('.onereach-trust-btn-notify').forEach(btn => {
      btn.addEventListener('click', openPopup);
    });
  }
});

/* ============================================================
   tsParticles — Hero Background (homepage only)
   ============================================================ */
const tsparticlesEl = document.getElementById('tsparticles');
if (tsparticlesEl && typeof tsParticles !== 'undefined') {
  tsParticles.load('tsparticles', {
    background: {
      color: { value: 'transparent' },
    },
    fpsLimit: 60,
    particles: {
      color: { value: ['#948874', '#ABBBFF', '#74777F', '#222428', '#E5E5E5'] },
      links: {
        color: '#948874',
        distance: 140,
        enable: true,
        opacity: 0.06,
        width: 0.7,
      },
      move: {
        enable: true,
        speed: 0.45,
        direction: 'none',
        random: true,
        straight: false,
        outModes: { default: 'bounce' },
      },
      number: {
        value: 55,
        density: { enable: true, area: 900 },
      },
      opacity: {
        value: { min: 0.15, max: 0.50 },
        animation: { enable: true, speed: 0.5, minimumValue: 0.08, sync: false },
      },
      shape: { type: 'circle' },
      size: { value: { min: 1, max: 2 } },
    },
    detectRetina: true,
  });
}

/* ============================================================
   Hamburger / Sidebar (mobile)
   ============================================================ */
const hamburger = document.getElementById('hamburger');
const sidebar   = document.getElementById('sidebar');
const overlay   = document.getElementById('overlay');

function openSidebar() {
  sidebar.classList.add('open');
  hamburger.classList.add('open');
  overlay.classList.add('active');
  document.body.style.overflow = 'hidden';
}

function closeSidebar() {
  sidebar.classList.remove('open');
  hamburger.classList.remove('open');
  overlay.classList.remove('active');
  document.body.style.overflow = '';
}

hamburger.addEventListener('click', () => {
  sidebar.classList.contains('open') ? closeSidebar() : openSidebar();
});

overlay.addEventListener('click', closeSidebar);

// Close sidebar and any open popup on Escape
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    closeSidebar();
    document.querySelectorAll('.onereach-trust-popup.is-open').forEach(popup => {
      popup.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }
});


/* ============================================================
   Sidebar nav — active state
   ============================================================ */
document.querySelectorAll('.onereach-trust-sidebar-nav li').forEach((li) => {
  li.addEventListener('click', () => {
    // Auto-close on mobile after selection
    if (window.innerWidth < 1024) closeSidebar();
  });
});